















































































































import Vue from "vue";
import AddCollection from "./AddCollection.vue";
import axios from "axios";
import SearchInput from "./SearchInput.vue";

const vm = Vue.component("Collections", {
  data: function() {
    return {
      showModal: false,
      searchQuery: "",
      collections: [],
      pagesCount: 0,
      pages: [1],
      currentPage: 1,
      diff: 0,
      translate: "translateX(0px)",
      foundTemplates: [],
      publicBtn: false,
    };
  },
  watch: {
    searchQuery: "getCollectionsFromQuery",
  },
  methods: {
    changeDiff: function(newDiff: number) {
      console.log("here");
      this.diff = newDiff;
    },
    updateCollectionAtServer: async function(
      id: number,
      name: string,
      index: number
    ) {
      try {
        let response = await axios.put(
          `${process.env.VUE_APP_API_URL}/api/v1/collection/${id}`,
          {
            name,
          },
          { withCredentials: true }
        );
        (this.collections[index] as any).isChanged = false;
      } catch (error) {
        console.log(error);
      }
    },
    updateCollectionName: function(value: string, index: number) {
      (this.collections[index] as any).isChanged = true;
    },
    moveToTemplates: function(collectionId: number) {
      this.$router.push({
        name: "collections_public/templates",
        params: { collectionId: collectionId.toString() },
      });
    },
    changeModalStatus: function() {
      this.showModal = !this.showModal;
    },
    handlePageChange: async function(page: number) {
      this.currentPage = page;
      this.getCollections(page);
    },

    getCollections: async function(page: number) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/v1/collections_admin/${page}/`,
          { withCredentials: true }
        );

        this.collections = response.data.collections.map((collection: any) => {
          return {
            ...collection,
            isChanged: false,
          };
        });
        this.pagesCount = response.data.amountOfPages;
        this.pages = Array.from(Array(response.data.amountOfPages).keys());
        this.$store.commit("setAuthorized");
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) {
          this.$router.push({
            path: `auth/`,
          });
        }
      }
    },
    getTemplatesInCollections: async function(query: string) {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/v1/collections_admin/1/${this.searchQuery}`,
          { withCredentials: true }
        );
        this.foundTemplates = response.data.templates;
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) {
          this.$router.push({
            path: `auth/`,
          });
        }
      }
    },
    getCollectionsFromQuery: function() {
      this.getTemplatesInCollections(this.searchQuery);
    },
    showAddedItems: function() {
      this.getCollections(1);
      this.changeModalStatus();
    },
  },
  mounted: function() {
    this.getCollections(1);
  },
  components: {
    AddCollection,
    SearchInput,
  },
});

export default vm;
